<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import Qs from 'qs'
import { mapActions, mapState } from 'vuex'
import { clone, isEmpty, filter, find } from 'lodash'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  name: 'SearchFilter',
  components: {
    SingleSelectInput,
  },
  data() {
    return {
      filters: {},
      isDisabled: true,
    }
  },
  computed: {
    ...mapState('ratingsLocation', ['filterOptions']),
    getDateType() {
      if (!isEmpty(this.filters.date_type)) {
        return this.filters.date_type.type
      }
      return false
    },
  },
  watch: {
    'filters.date_type'(val, oldVal) {
      if (val !== oldVal) {
        this.setDateValue(val)
      }
    },
  },
  created() {
    this.onResetFilter()
  },
  methods: {
    ...mapActions('ratingsLocation', [
      'resetFilter',
      'getRatingsFilters',
      'updateFilters',
    ]),
    filterResults(identifier, props) {
      if (identifier === 'date') {
        return filter(props, i => i.type === this.getDateType)
      }
      return props
    },
    setDateValue(date) {
      if (date) {
        if (this.filterOptions && Array.isArray(this.filterOptions)) {
          this.filterOptions.forEach(e => {
            if (e.identifier === 'date') {
              const obj = find(e.properties, f => f.type === date.type)
              this.$set(this.filters, e.identifier, obj)
            }
          })
        }
      }
    },
    onResetFilter() {
      this.filters = {}
      this.resetFilter()
      this.getRatingsFilters().then(_ => {
        if (this.filterOptions && Array.isArray(this.filterOptions)) {
          this.filterOptions.forEach(e => {
            if (e.identifier === 'sorting_order' || e.identifier === 'date_type' || e.identifier === 'date') {
              this.$set(this.filters, e.identifier, e.properties[0])
            }
          })
        }
      })
      this.$emit('onResetFilter')
      this.isDisabled = true
    },
    onResultUpdate(id, args) {
      this.$set(this.filters, id, args)
      this.updateFilters(clone(this.filters))
      this.isDisabled = false
    },
    getExportURL() {
      const filterObj = Qs.stringify({ ...this.filters, locale: this.$i18n.formatedLocale }, { arrayFormat: 'brackets' })
      return `${process.env.VUE_APP_API_URL}ratings/ratings_export?${filterObj}`
    },
  },
}
</script>
